import db from '../../js/db'
import * as types from '../mutations-types'
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import { firestoreAction, vuexfireMutations } from 'vuexfire'

const state = {
  my: {},
}

// getters
const getters = {
  myPlan: (state, getters, rootState, rootGetters) => getMyPlan(state, getters, rootState, rootGetters),
  planDefault: (state, getters, rootState, rootGetters) => getPlanDefault(state, getters, rootState, rootGetters),
  svincolatiPerAutocomplete: (state, getters, rootState, rootGetters) => getSvincolatiPerAutocomplete(state, getters, rootState, rootGetters),
  associati: (state, getters, rootState, rootGetters) => getAssociati(state, getters, rootState, rootGetters),
}

function getAssociati(state, getters, rootState, rootGetters) {
  let output = [];
  const myPlan = getters.myPlan
  for (const ruolo_abc in myPlan) {
    for (const i in myPlan[ruolo_abc]) {
      const associato = myPlan[ruolo_abc][i]["associato"];
      if (associato != "") {
        output.push(associato);
      }
    }
  }
  return output;
}

function getMyPlan(state, getters, rootState, rootGetters) {
  const my_squadra = rootGetters.my_squadra;
  let output = {};
  if (my_squadra) {
    output = _.assign({}, getters.planDefault)
    // output = getters.planDefault
    // copia tutti valori custom
    // const plan = my_squadra.plan;
    // const plan = state.my;
    const plan = _.assign({}, state.my)
    for (const ruolo_abc in plan) {
      for (const i in plan[ruolo_abc]) {
        // ma solo se i esiste ancora (admin potrebbe aver diminuito i ruoli)
        if (output[ruolo_abc][i] !== undefined) {
          for (const field in plan[ruolo_abc][i]) {
            output[ruolo_abc][i][field] = plan[ruolo_abc][i][field];
          }
          // togli associato se non è + nella mia rosa
          const associato = output[ruolo_abc][i]["associato"];
          if (
            associato != "" &&
            (!my_squadra.calciatori ||
              !my_squadra.calciatori[associato])
          ) {
            output[ruolo_abc][i]["associato"] = ""; // vorrei delete ma nn va. tbd
          }
        }
      }
    }
  }
  return output;
}

// function getMyPlan(state, getters, rootState, rootGetters) {
//   const my_squadra = rootGetters.my_squadra;
//   console.log('my_squadra', my_squadra)
//   let output = {};
//   if (my_squadra) {
//     console.log('getMyPlan')
//     const planDefault = getters.planDefault;
//     const planInDb = state.my_plan
//     const myCalciatori = my_squadra.calciatori
//     const memo = _.memoize((planDefault, planInDb, myCalciatori) => {
//       let output = {};
//       output = _.assign({}, planDefault)
//       console.log('output', output)
//       // copia tutti valori custom
//       // const plan = my_squadra.plan;
//       // const plan = state.my_plan;
//       const plan = _.assign({}, planInDb)
//       for (const ruolo_abc in plan) {
//         for (const i in plan[ruolo_abc]) {
//           // ma solo se i esiste ancora (admin potrebbe aver diminuito i ruoli)
//           if (output[ruolo_abc][i] !== undefined) {
//             for (const field in plan[ruolo_abc][i]) {
//               output[ruolo_abc][i][field] = plan[ruolo_abc][i][field];
//               console.log('output', output)
//             }
//             // togli associato se non è + nella mia rosa
//             const associato = output[ruolo_abc][i]["associato"];
//             if (
//               associato != "" &&
//               (!myCalciatori ||
//                 !myCalciatori[associato])
//             ) {
//               output[ruolo_abc][i]["associato"] = ""; // vorrei delete ma nn va. tbd
//               console.log('output', output)
//             }
//           }
//         }
//       }
//       return output;
//     });
//     return memo(planDefault, planInDb, myCalciatori);
//   }
//   return output;
// }

function getPlanDefault(state, getters, rootState, rootGetters) {
  const my_squadra = rootGetters.my_squadra;
  const asta_info = rootGetters.asta_info;
  let output = {};
  for (const ruolo_abc in Constants.RUOLO) {
    const ruolo_id = Constants.RUOLO[ruolo_abc];
    let nRuolo = 0;
    if (asta_info.lega.nRuoli.op == "illimitati") {
      nRuolo =
        my_squadra.settings.plan.nRuoli[Helpers.ruoloLega(ruolo_id)];
    } else {
      nRuolo = asta_info.lega.nRuoli[Helpers.ruoloLega(ruolo_id)];
    }
    output[ruolo_abc] = planRuoloDefault(nRuolo);
  }
  return output;
}

function getSvincolatiPerAutocomplete(state, getters, rootState, rootGetters) {
  let output = {};
  const nameFilter = "";
  const maxQuotazione = 0;
  const includiScartati = false;
  for (const ruolo_abc in Constants.RUOLO) {
    const ruolo_id = Constants.RUOLO[ruolo_abc];
    let ids = rootGetters.svincolati(
      ruolo_id,
      nameFilter,
      maxQuotazione,
      includiScartati
    );
    let objects = _.map(ids, (id) => {
      return {
        text: rootGetters.calciatori[id].calciatore,
        value: id,
      };
    });
    output[ruolo_abc] = objects;
  }
  return output;
}

function planRuoloDefault(nRuolo) {
  let output = {};
  for (let i = 1; i <= nRuolo; i++) {
    output["_" + i] = {
      calciatori: [],
      crediti: 0,
      associato: "",
    };
  }
  return output;
}

// actions
const actions = {
  fetchMyPlan() {
    db.fetchMyPlan()
  },
  // not used
  updateMyPlan({
    commit,
    state
  }, value) {
    commit(types.PLAN_UPD, value)
  }
}

// mutations
const mutations = {
  [types.PLAN_SET](state, plan) {
    state.my = plan;
  },
  [types.PLAN_UPD](state, values) {
    state.my = _.merge(state.my, values)
  },
  [types.PLAN_CLR](state) {
    state.my = {};
  },
  ...vuexfireMutations
}

export default {
  state,
  getters,
  actions,
  mutations
}